export default "__VITE_ASSET__53HX5orB__"